import { FC, createElement, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useJourneyTree } from '../../../hooks/use-journey-tree';
import { ROUTES } from '../../../routes';
import { CitizenJourney, CitizenJourneyProps } from './citizen-journey';

const HIGHLIGHT_SIZE = 6;

export const CitizenJourneyContainer: FC = () => {
  const history = useHistory();
  const journeyTree = useJourneyTree();

  const onClickJourney = useCallback(
    (slug: string) => {
      history.push(`${ROUTES.JOURNEY_LIST_PAGE}/${slug}`);
    },
    [history]
  );

  const onClickSeeAll = useCallback(() => {
    history.push(ROUTES.JOURNEY_LIST_PAGE);
  }, [history]);

  const citizenJourneyProps: CitizenJourneyProps = {
    journeys: journeyTree.slice(0, HIGHLIGHT_SIZE),
    onClickJourney,
    onClickSeeAll,
  };

  return createElement(CitizenJourney, citizenJourneyProps);
};
